const regExToMessageList = [
  {
    regEx: /hard credit pull failed for the application/i,
    message: 'Hard credit pull failed for the application.',
  },
  {
    regEx: /Email must be verified prior to signing a contract/i,
    message: 'Email must be verified prior to signing a contract.',
  },
  {
    regEx: /Promissory note has already been signed/i,
    message: 'Promissory note has already been signed.',
  },
  {
    regEx: /loan_amount is less than the contract_pricing.min_loan_amount/i,
    message: 'Loan amount is less than the minimum amount.',
  },
  {
    regEx: /loan_amount is greater than the contract_pricing.max_loan_amount/i,
    message: 'Loan amount is more than the maximum amount.',
  },
  {
    regEx: /selected rate does not belong to the application/i,
    message: 'The selected rate does not belong to the application.',
  },
  {
    regEx: /application is not approved for selected rate/i,
    message: 'The application is not approved for the selected rate.',
  },
  {
    regEx: /application is not in_progress and can not rate accept/i,
    message: 'The application is not in progress and can not rate accept.',
  },
  {
    regEx: /vehicle ltv is greater than the product_configuration.max_ltv/i,
    message: "The vehicle's LTV is greater than what is acceptable.",
  },
  {
    regEx: /We were unable to pull the applicant's credit report with the provided information/,
    message: "Upstart is not able to process this application because we are unable to retrieve a matching credit report from TransUnion based on the applicant's name, address, and SSN. The applicant should check the information they submitted on their credit application and, if correct, contact TransUnion to correct information on file."
  },
  {
    regEx: /The SSN provided by the applicant does not match the SSN from the Credit Bureau/,
    message: "Upstart was able to pull the applicant's credit report, but the SSN provided does not match the SSN on the credit report received. This mismatch could be due to a typo by the customer, or incorrect information in TransUnion's credit report. Upstart will not be able to offer an approval unless the SSN mismatch is corrected. If the SSN entered is verified as correct, please contract TransUnion to correct their information on file and resubmit."
  },
  {
    regEx: /The applicant's credit report is suppressed/,
    message: "Upstart cannot process this application because the applicant's TransUnion credit report is frozen. The applicant will need to contact TransUnion to have the freeze lifted and re-apply.",
  },
  {
    regEx: /The applicant is required to live in the same state as the dealership/,
    message: "Upstart cannot process this application because the applicant's address is in a different state from the dealership. Upstart currently only supports applicant addresses in the same state as the dealership.",
  },
  {
    regEx: /Vehicle data could not be found for this VIN/,
    message: 'Upstart cannot offer a rate on this vehicle because Kelly Blue Book and Black Book did not return any vehicle information for this VIN.',
  },
  {
    regEx: /Application is currently being processed, please wait/,
    message: 'An application with this email is currently being processed, please wait or try submitting an application with a different email.',
  },
  {
    regEx: /Not enough vehicle data was available for this VIN/,
    message: 'Upstart cannot offer a rate for this vehicle because Kelly Blue Book and Black Book did not return enough pricing information for Upstart to value the vehicle.',
  },
  {
    regEx: /There was an error pulling the credit report/,
    message: 'Upstart is not able to currently retrieve the credit report due to a potential outage or other connectivity issue, or there are possible irregular values on the credit report (Deceased, OFAC warning, etc).',
  },
  {
    regEx: /The rooftop supplied is not present in our system/,
    message: 'Your dealership is not currently registered for Upstart lending. Please contact support at 800-535-9749 or dealersupport@upstart.com to correct this issue.',
  },
  {
    regEx: /An unhandled exception has occurred. Please try again later/,
    message: 'An unexpected error has occurred. Please try again later or contact support at 800-535-9749 or dealersupport@upstart.com',
  },
  {
    regEx: /address is in a state that Upstart does not support. Out of state lending is not enabled for this state/i,
    message: "Upstart cannot process this application because the applicant's address is in a state that Upstart does not support. Out of state lending is not enabled for this state"
  }
];

export const getUserMessage = (exceptionMessage: string) => {
  const match = regExToMessageList.find(msgItem =>
    msgItem.regEx.test(exceptionMessage),
  );
  return match ? match.message : exceptionMessage;
};

export const cleanDMSPushErrors = (errorMessage?: string): string => {
  if (!errorMessage) {
    return 'Failed to push offer to DMS';
  }

  let cleanMessage = errorMessage;

  const isDuplicateVinError = /Duplicate VIN error/.test(errorMessage);
  if (isDuplicateVinError) {
    cleanMessage =
      'Another active deal is already using a trade-in with the same VIN as the trade-in on this deal. To proceed, please remove the trade-in from the other active deal in the DMS or from the current deal.';
  }

  return `Failed to push offer to DMS: ${cleanMessage}`;
};
